import React, { useState, useCallback } from 'react'
import DebtAmount from './sections/DebtAmount'
import Qualify from './sections/AreYouQualify'
import { paymentsReferenceTable as deafultPaymentValues } from '../SliderCTA/data'
import BarDetail from './sections/BarDetail'
import { numberFormat } from 'src/common/utils'
import { useNavigateToApply } from 'src/common/hooks/useNavigateToApply'
import { useAnalytics } from 'src/common/analytics'

const amountFormatOptions = {
  style: 'currency',
  currency: 'USD',
}

const DebtReliefCalculatorV4 = ({
  data,
  initialAmount = 25000,
  cfosData,
  isCfosDisclousuresVariationActive,
}) => {
  const useCfosData = cfosData && isCfosDisclousuresVariationActive
  const paymentsReferenceTable = useCfosData ? cfosData : deafultPaymentValues
  const defaultValue =
    paymentsReferenceTable[initialAmount] &&
    paymentsReferenceTable[initialAmount][0]
      ? initialAmount
      : 25000

  const [selectedAmount, setSelectedAmount] = useState(defaultValue)
  const values = Object.keys(paymentsReferenceTable)

  const { track } = useAnalytics()
  const { navigateToApply, getUrl } = useNavigateToApply({
    estimated_debt: selectedAmount,
  })

  const handleAmountChange = (e) => setSelectedAmount(e.target.value)

  const amountDescription = (amount) => {
    const parts = data.amountDescription.split('${amount}')

    return (
      <>
        {parts.length === 1 ? (
          parts[0]
        ) : (
          <>
            {parts[0]}
            <span>{amount}</span>
            {parts[1]}
          </>
        )}
      </>
    )
  }

  const handleClick = (e, params = {}) => {
    e.preventDefault()
    const variationText = e.target.innerText

    const data = {
      nav_link_section: 'Debt relief calc',
      page_section: 'You may free up $ on your monthly payment',
      click_type: 'Button Click',
      click_id: variationText,
      click_text: `FDR-Web | ${variationText}`,
      form_ss_amount: +selectedAmount,
      track_event: 'button_click',
      ...params,
    }

    track(
      data,
      {
        event_type: 'conversion',
      },
      'button_click'
    )

    navigateToApply()
  }

  const [showModal, setShowModal] = useState(false)
  const [modalScrollTarget, setModalScrollTarget] = useState(null)

  const handleModalOpen = useCallback((scrollTarget = null) => {
    setModalScrollTarget(scrollTarget)
    setShowModal(true)
    document.body.style.overflow = 'hidden'
  }, [])

  const handleModalClose = useCallback(() => {
    setShowModal(false)
    setModalScrollTarget(null)
    document.body.style.overflow = 'unset'
  }, [])

  const rowValues =
    paymentsReferenceTable[selectedAmount] || paymentsReferenceTable[25000]
  const currentMinPayment = rowValues[0]
  const reliefMonthlyPayment = rowValues[2]

  return (
    <section className="w-full bg-secondary px-secondary py-12 lg:px-8">
      <div className="max-w-110 lg:max-w-304 mx-auto flex rounded-20 bg-white px-4 py-6 lg:items-end lg:justify-center lg:gap-12 lg:px-4 lg:py-12">
        <div className="lg:max-w-124 lg:w-[50%]" style={{ width: '100%' }}>
          <DebtAmount
            selectedAmount={selectedAmount}
            handleAmountChange={handleAmountChange}
            options={values}
            data={{ title: data.title, question: data.question }}
            amountFormatOptions={amountFormatOptions}
          />
          <div className="h-91 mt-6 mb-4 md:h-[341px] lg:hidden">
            <BarDetail
              currentMinPayment={currentMinPayment}
              reliefMonthlyPayment={reliefMonthlyPayment}
              amountFormatOptions={amountFormatOptions}
            />
          </div>
          <div className="hidden lg:block">
            <div className="mt-8 flex justify-between gap-2">
              <span
                onClick={() => handleModalOpen('disclosure-star')}
                className="cursor-pointer text-base font-normal leading-[140%] text-content-primary"
              >
                Current min. payments to creditors <sup>*</sup>
              </span>
              <span className="text-base font-bold leading-[140%] text-content-primary">
                {numberFormat(currentMinPayment, amountFormatOptions)}/month
              </span>
            </div>
            <div className="mt-8 flex justify-between gap-2">
              <span
                onClick={() => handleModalOpen('disclosure-double-star')}
                className="cursor-pointer text-base font-normal leading-[140%] text-content-primary"
              >
                With Freedom Debt Relief <sup>**</sup>
              </span>
              <span className="text-base font-bold leading-[140%] text-content-primary">
                {numberFormat(reliefMonthlyPayment, amountFormatOptions)}/month
              </span>
            </div>
          </div>
          <div className="mt-4 lg:mt-8">
            <Qualify
              data={{
                amountDescription: amountDescription(
                  numberFormat(
                    paymentsReferenceTable[selectedAmount][0] -
                      paymentsReferenceTable[selectedAmount][2],
                    amountFormatOptions
                  )
                ),
                buttonText: data.buttonText,
              }}
              handleClick={handleClick}
              getUrl={getUrl}
              showModal={showModal}
              modalScrollTarget={modalScrollTarget}
              onModalOpen={handleModalOpen}
              onModalClose={handleModalClose}
            />
          </div>
        </div>
        <div className="lg:max-w-120 hidden self-stretch lg:flex lg:w-[50%]">
          <BarDetail
            currentMinPayment={currentMinPayment}
            reliefMonthlyPayment={reliefMonthlyPayment}
            amountFormatOptions={amountFormatOptions}
            heightBar={476}
          />
        </div>
      </div>
    </section>
  )
}

export default DebtReliefCalculatorV4
